import { useCallback } from 'react'
import { useLatestLoad } from '../../hooks/useLatestLoad'
import { fetchCustomers } from '../adminApi'
import type { RequestOptions } from '../../core/types/backend'
import type { CustomerSummary } from '../../core/types/adminRequests'

const none: CustomerSummary[] = []

/**
 * De klantenlijst van het beheer (GET /admin/customers). `enabled: false` = niet ophalen (bijv.
 * voor een collega in de zoekfunctie): de lijst blijft leeg en er gaat geen verzoek de deur uit.
 */
export function useCustomers(enabled = true) {
  const load = useCallback((opts?: RequestOptions) => (enabled ? fetchCustomers(opts) : Promise.resolve(none)), [enabled])
  const { data, status, reload } = useLatestLoad(load)
  return { customers: data ?? none, status, reload }
}
